import jwtDecode from 'jwt-decode'

// this should be an api call but for now we just hard code
const PAGE_PERMISSIONS = {
  '/review-request': [
    'SuperAdmin',
    'Admin',
    'Manager',
    'MasterTech'
  ],
  '/admin': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/import-data': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/usps/check': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/usps/process': [
    'SuperAdmin',
    'Admin'
  ],
  '/dashboard': [
    'SuperAdmin',
    'Admin',
    'Manager'
  ]
}

export default {
  token: state => state.token,
  passthrough: state => state.passthrough,
  user: state => state.token ? jwtDecode(state.token) : {},
  isAllowed: (state) => {
    return (page = '') => {
      if (!PAGE_PERMISSIONS[page]) { return true }
      if (state.roles && state.roles.length) {
        return state.roles.some(r => PAGE_PERMISSIONS[page].includes(r))
      }
      return PAGE_PERMISSIONS[page].includes('Guest')
    }
  },
  userProfile: state => state.userProfile,
  roles: state => state.roles,
  primaryRole: (state) => {
    let _role = ''
    for (let role of state.roles) {
      if (role === 'InShopTech' || role === 'DiagCoord') {
        _role = 'Tech'
        break
      } else if (role === 'MasterTech') {
        _role = 'MasterTech'
        break
      } else if (role === 'Dispatch') {
        _role = 'Dispatch'
        break
      }
    }
    return _role
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js